import { c as _c } from "react/compiler-runtime";
type CardBaseProps = {
  id: string;
  isSelected?: boolean;
  onSelect?: () => void;
  title?: React.ReactNode;
  headerIcon: React.ReactNode;
  headerText: string;
  rows: React.ReactNode[];
  cta?: React.ReactNode;
};
const CardBase = t0 => {
  const $ = _c(28);
  const {
    id,
    isSelected,
    onSelect,
    title,
    headerIcon,
    headerText,
    rows,
    cta
  } = t0;
  let t1;
  if ($[0] !== id || $[1] !== onSelect) {
    t1 = () => {
      const card = document.getElementById(`device-insights-card-${id}`);
      const parent = card?.parentElement;
      if (card && parent) {
        parent.scrollTo({
          top: card.offsetTop,
          behavior: "smooth"
        });
      }
      onSelect?.();
    };
    $[0] = id;
    $[1] = onSelect;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleSelect = t1;
  const t2 = `device-insights-card-${id}`;
  const t3 = !!isSelected;
  let t4;
  if ($[3] !== handleSelect) {
    t4 = event => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        handleSelect();
      }
    };
    $[3] = handleSelect;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = !!isSelected;
  let t6;
  if ($[5] !== title) {
    t6 = title && <div className="flex flex-col justify-center items-center p-2 w-full h-full border-b border-tertiary bg-secondary rounded-t data-[selected=true]:border-secondary"><div className="text-caption-1 text-primary">{title}</div></div>;
    $[5] = title;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== headerIcon) {
    t7 = <div className="rounded-full bg-tertiary flex justify-center items-center w-8 h-8">{headerIcon}</div>;
    $[7] = headerIcon;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== headerText) {
    t8 = <div className="text-label-2 text-primary">{headerText}</div>;
    $[9] = headerText;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t7 || $[12] !== t8) {
    t9 = <div className="flex flex-col justify-center items-center w-full gap-3">{t7}{t8}</div>;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== rows) {
    t10 = <div className="w-full flex flex-col justify-center items-center gap-1">{rows}</div>;
    $[14] = rows;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== cta || $[17] !== t10 || $[18] !== t9) {
    t11 = <div className="flex flex-col justify-center items-center p-4 w-full h-full gap-4">{t9}{t10}{cta}</div>;
    $[16] = cta;
    $[17] = t10;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== handleSelect || $[21] !== t11 || $[22] !== t2 || $[23] !== t3 || $[24] !== t4 || $[25] !== t5 || $[26] !== t6) {
    t12 = <div id={t2} data-selected={t3} onClick={handleSelect} onKeyDown={t4} role="button" tabIndex={0} aria-pressed={t5} className="flex flex-col border border-tertiary rounded bg-primary cursor-pointer relative hover:bg-hover data-[selected=true]:border-secondary data-[selected=true]:after:content-[''] data-[selected=true]:after:absolute data-[selected=true]:after:inset-0 data-[selected=true]:after:bg-accent data-[selected=true]:after:opacity-[0.1]">{t6}{t11}</div>;
    $[20] = handleSelect;
    $[21] = t11;
    $[22] = t2;
    $[23] = t3;
    $[24] = t4;
    $[25] = t5;
    $[26] = t6;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  return t12;
};
export default CardBase;